import JarvisHttpService from "Jarvis/JarvisServices/JarvisHttpService";
import JarvisBaseSettingsService from "Jarvis/JarvisServices/JarvisBaseSettingsService";
import {
  ifNullOrWhiteSpace,
  isNullOrWhiteSpace,
} from "Jarvis/JarvisServices/JarvisCommonService";

export const JobActivityTypeRetrieve = async ({
  pageIndex,
  pageSize,
  totalRecords,
  orderBy,
  orderBys,
  orderMethod,
  where,
  node,
  retrieveAsList,
  hierarchyShowMode,
  latestNodeLevel,
  isDeepSearchNeeded,
}) => {
  const retrieveService =
    !isNullOrWhiteSpace(retrieveAsList) && retrieveAsList === true
      ? "Pms/JobActivityType/RetrieveAsList"
      : "Pms/JobActivityType/Retrieve";

  const hierarchy = {
    HierarchyShowMode: ifNullOrWhiteSpace(hierarchyShowMode, "Table"),
    LatestNodeLevel: ifNullOrWhiteSpace(latestNodeLevel, null),
    NodeId: node?.["JobActivityTypeId"],
    VT: node?.VT,
    isDeepSearchNeeded,
  };

  const { data } = await JarvisHttpService.post({
    url: JarvisBaseSettingsService.getApiEndPoint("Jarvis") + retrieveService,
    data: {
      pageIndex,
      pageSize,
      totalRecords,
      hierarchy,
      orderBy,
      orderBys,
      orderMethod,
      where,
    },
  });
  return data;
};

export const JobActivityTypeCreate = async (_data) => {
  const { data } = await JarvisHttpService.post({
    url:
      JarvisBaseSettingsService.getApiEndPoint("Jarvis") +
      "Pms/JobActivityType/Create",
    data: _data,
  });
  return data;
};

export const JobActivityTypeUpdate = async (_data) => {
  const { data } = await JarvisHttpService.post({
    url:
      JarvisBaseSettingsService.getApiEndPoint("Jarvis") +
      "Pms/JobActivityType/Update",
    data: _data,
  });
  return data;
};

export const JobActivityTypeDelete = async ({
  JobActivityTypeId,
  VT,
  LastUpdateDateTime,
}) => {
  const { data } = await JarvisHttpService.post({
    url:
      JarvisBaseSettingsService.getApiEndPoint("Jarvis") +
      "Pms/JobActivityType/Delete",
    data: { JobActivityTypeId, VT, LastUpdateDateTime },
  });
  return data;
};
